import { ReactElement } from 'react'
import LocationSelector from 'app/components/analytics/LocationSelector'
import { useIsMobile } from 'app/hooks/useMediaQuery'
import { useLocationFilter } from 'app/hooks/useLocationFilter'

/**
 * Location filter for the pipelines board. Renders the same analytics `LocationSelector`
 * as the marketing dashboard (integration badges + PMS pseudo-options) and shares its
 * `locationIds` / `integrationStatus` URL-param wiring via `useLocationFilter`.
 * `usePipelinesPage` reads those params to filter the pipeline's contacts. Selection lives
 * in the URL, so it persists across pipeline sub-pages (tabs).
 */
export function PipelineLocationSelector(): ReactElement {
  const isMobile = useIsMobile()
  const { selectedOptions, locationOptions, deselectAllOptions, onLocationChange } = useLocationFilter()

  return (
    <LocationSelector
      selectedOptions={selectedOptions}
      locationOptions={locationOptions}
      deselectAllOptions={deselectAllOptions}
      onChange={onLocationChange}
      hideLabel={isMobile}
    />
  )
}
